import React from 'react';
import { calculateLeadScore } from '../../utils/scoring';
import { Lead } from '../../types/lead';
import { CheckCircle2, Circle, TrendingUp } from 'lucide-react';
interface ScoreBreakdownProps {
  lead: Lead;
}
export function ScoreBreakdown({
  lead
}: ScoreBreakdownProps) {
  const {
    score,
    breakdown
  } = calculateLeadScore(lead);
  const maxScore = breakdown.reduce((sum, item) => sum + item.points, 0);
  const percentage = maxScore > 0 ? score / maxScore * 100 : 0;
  const tier = score >= 70 ? 'A' : score >= 40 ? 'B' : 'C';
  const tierMeta = {
    A: {
      label: 'Alta prioridad',
      color: 'text-growthly-green',
      bg: 'bg-growthly-green/10',
      barFrom: 'from-growthly-green',
      barTo: 'to-emerald-400'
    },
    B: {
      label: 'Prioridad media',
      color: 'text-growthly-amber',
      bg: 'bg-growthly-amber/10',
      barFrom: 'from-growthly-amber',
      barTo: 'to-orange-400'
    },
    C: {
      label: 'Baja prioridad',
      color: 'text-growthly-muted',
      bg: 'bg-white/5',
      barFrom: 'from-white/30',
      barTo: 'to-white/20'
    }
  }[tier];
  const appliedCount = breakdown.filter(b => b.applied).length;
  return <div className="card p-6" data-id="element-690">
      {/* Header with big score */}
      <div className="flex items-start justify-between mb-5" data-id="element-691">
        <div data-id="element-692">
          <div className="flex items-center gap-2 mb-1" data-id="element-693">
            <TrendingUp className="w-4 h-4 text-growthly-muted" data-id="element-694" />
            <h3 className="text-[14px] font-semibold text-white" data-id="element-695">
              Desglose de Score
            </h3>
          </div>
          <p className={`text-[12px] font-medium ${tierMeta.color}`} data-id="element-696">
            {tierMeta.label}
          </p>
        </div>
        <div className="text-right" data-id="element-697">
          <div className="flex items-baseline gap-1" data-id="element-698">
            <span className="text-[36px] font-bold text-white leading-none tracking-tight" data-id="element-699">
              {score}
            </span>
            <span className="text-[14px] text-growthly-muted font-medium" data-id="element-700">
              /{maxScore}
            </span>
          </div>
          <p className="text-[10px] text-growthly-muted uppercase tracking-wider mt-1" data-id="element-701">
            {appliedCount} de {breakdown.length} reglas
          </p>
        </div>
      </div>

      {/* Progress bar */}
      <div className="mb-6" data-id="element-702">
        <div className="h-2 bg-white/5 rounded-full overflow-hidden" data-id="element-703">
          <div className={`h-full bg-gradient-to-r ${tierMeta.barFrom} ${tierMeta.barTo} rounded-full transition-all duration-500 ease-out`} style={{
          width: `${Math.min(percentage, 100)}%`
        }} data-id="element-704" />
        </div>
      </div>

      {/* Rules list */}
      <div className="space-y-1.5" data-id="element-705">
        {breakdown.map((item, idx) => <div key={idx} className={`flex items-center justify-between text-[13px] px-3 py-2.5 rounded-lg transition-colors ${item.applied ? 'bg-white/[0.04] border border-white/5' : 'border border-transparent hover:bg-white/[0.02]'}`} data-id="element-706">
            <div className="flex items-center gap-2.5 min-w-0" data-id="element-707">
              {item.applied ? <CheckCircle2 className="w-4 h-4 text-growthly-green flex-shrink-0" data-id="element-708" /> : <Circle className="w-4 h-4 text-white/15 flex-shrink-0" data-id="element-709" />}
              <span className={`truncate ${item.applied ? 'text-white' : 'text-growthly-muted'}`} data-id="element-710">
                {item.rule}
              </span>
            </div>
            <span className={`text-[12px] font-bold flex-shrink-0 ml-2 ${item.applied ? 'text-growthly-green' : 'text-growthly-muted/50'}`} data-id="element-711">
              +{item.points}
            </span>
          </div>)}
      </div>
    </div>;
}